import i18n from 'localization';

export const errorCodeTypes = {
  emptyTenantLeaseSuiteIdError: {
    code: 'TN02',
    name: 'EmptyTenantLeaseSuiteIdError',
    message: i18n.t('tenants.errors.emptyTenantLeaseSuiteId'),
  },
  tenantNotFoundError: {
    code: 'TN03',
    name: 'TenantNotFoundError',
    message: i18n.t('tenants.errors.tenantNotFound'),
  },
  tenantSuiteNotFoundError: {
    code: 'TN04',
    name: 'TenantSuiteNotFoundError',
    message: i18n.t('tenants.errors.tenantSuiteNotFound'),
  },
  addTenantLeaseError: {
    code: 'TN05',
    name: 'AddTenantLeaseError',
    message: i18n.t('tenants.errors.addTenantLeaseFailed'),
  },
  removeTenantLeaseError: {
    code: 'TN06',
    name: 'RemoveTenantLeaseError',
    message: i18n.t('tenants.errors.removeTenantLeaseFailed'),
  },
  getTenantLeaseError: {
    code: 'TN07',
    name: 'GetTenantLeaseError',
    message: i18n.t('tenants.errors.getTenantLeaseFailed'),
  },
  emptyTenantLeaseSourceTypeError: {
    code: 'TN08',
    name: 'EmptyTenantLeaseSourceTypeError',
    message: i18n.t('tenants.errors.emptyTenantLeaseSourceType'),
  },
  emptyTenantLeaseIdError: {
    code: 'TN09',
    name: 'EmptyTenantLeaseIdError',
    message: i18n.t('tenants.errors.emptyTenantLeaseId'),
  },
};
